import { ProgressStepperCurrentLabel } from './ProgressStepperCurrentLabel';

// TODO: in v9, move styled() from ProgressStepperCurrentLabel.jsx to here
export var StyledProgressStepperCurrentLabel = ProgressStepperCurrentLabel;